import { PathBase } from "@constellation-academy/epic-ui";

export class MessageDefinitionEditPath extends PathBase {
	static readonly pathKey = "edit";
}
